<template>
    <div class="mb-2" v-if="!(empty.removed == true && comm == null)">
        <Input groupClass="bg-grey text-15" :disabled="empty.removed" v-model:value="empty.value" :canFoucs="false">
            <template #left v-if="canBeToggled">
                <input
                    type="radio"
                    class="input-radio mt-0 !mr-0 ml-3"
                    :disabled="empty.value == '' || empty.removed"
                    :checked="empty.primary"
                    :name="empty.name()"
                    @change="
                        () => {
                            // console.log(empty)
                            this.empty.primary = true
                            this.$event.$emit('communication-primary-change', this.empty)
                        }
                    "
                />
            </template>

            <template #right>
                <div class="flex items-center" v-if="empty.primary">
                    <p class="text-green-600 font-semibold text-14">PRIMARY</p>

                    <Tooltip
                        trigger="hover"
                        :text="'The primary ' + empty.label() + ' is used by default to ' + empty.action() + ' your contact'"
                    />
                </div>

                <button
                    type="button"
                    v-if="!empty.primary && canBeToggled"
                    @click="destroy"
                    class="pr-3"
                    :class="[empty.primary ? 'stroke-grey-800' : 'stroke-black']"
                    v-tippy="
                        empty.primary
                            ? 'You will need to add a new default ' + empty.label() + ' before you can delete this ' + empty.label()
                            : ''
                    "
                >
                    <IconReply v-if="empty.removed" class="w-4.5 h-4.5" />
                    <IconDelete v-else class="w-4.5 h-4.5" />
                </button>

                <!-- <ToggleRadio :checked='empty.primary'
					:disabled='empty.value == "" || empty.removed'
					checkedClass='bg-green-600'
					@change='empty.primary = true; $nuxt.$emit("communication-primary-change", empty.type, empty.value)' /> -->
            </template>
        </Input>

        <!-- <Error v-if='errors.value != null' :error='errors.value[0]' /> -->

        <div class="pt-2 flex items-start error" v-if="errors.value != null">
            <IconFalse class="w-5 h-5 stroke-red-700 bg-red-700 shrink-0 rounded-full bg-opacity-10 mr-2" />

            <p class="error text-error text-14" v-html="errors.value[0]" />
        </div>

        <p class="text-12 text-red-700 pt-1" v-if="empty.removed">This {{ empty.label() }} will be deleted once changes are saved</p>
    </div>
</template>

<script>
import Communication from '~/models/communication.js'
import Errors from '~/models/errors.js'

export default {
    props: {
        type: Number,
        modelType: String,
        modelId: Number,
        comm: Object,
        owner: Object,
        canBeToggled: { type: Boolean, default: false },
    },

    emits: ['hasSaved', 'hasDeleted'],

    mounted() {
        this.$event.$on('communication-primary-change', (newPrimary) => {
            // console.log(newPrimary.value, this.empty.value)
            if (this.empty.type == newPrimary.type && this.empty.value != newPrimary.value) {
                // console.log('not primary anymore', this.empty.value)
                this.empty.primary = false
            }
        })

        this.$event.$on('communication-save', () => {
            this.save()
        })

        this.$event.$on('communication-delete', () => {
            this.remove()
        })

        if (this.type == 0) {
            this.empty.value = this.empty.toString()
        }
    },

    unmounted() {
        this.$event.$off('communication-save')
        this.$event.$off('communication-delete')
        this.$event.$off('communication-primary-change')
    },

    data() {
        return {
            empty: new Communication({
                type: this.type,
                value: this.comm ? this.comm.value : '',
                // primary: this.comm ? this.comm.primary == 1 : false,
                primary: this.owner != null && this.owner[parseInt(this.type) == 0 ? 'primary_phone' : 'primary_email'] == this.comm?.id,
                removed: false,
                $help: this.$help,
            }),
            errors: new Errors(),
        }
    },

    methods: {
        remove() {
            this.errors = new Errors()
            // console.log('remove', [this.empty.removed, this.comm])

            if (this.empty.removed == true && this.comm.id != null) {
                this.$axios
                    .delete('/communication/' + this.comm.id)
                    .then(() => {
                        this.$emit('hasDeleted')
                    })
                    .catch((error) => {
                        this.errors = new Errors(error.data.errors).errors
                        this.$emit('error')
                    })

                return
            } else {
                this.$emit('hasDeleted')
            }
        },

        save() {
            this.errors = new Errors()

            if (this.empty.removed == true && this.comm == null) {
                this.$emit('hasSaved')
                return
            }

            if (this.comm != null) {
                this.$axios
                    .post('/communication/' + this.comm.id, {
                        value: this.empty.value,
                        primary: this.empty.primary,
                    })
                    .then(() => {
                        this.$emit('hasSaved')
                    })
                    .catch((error) => {
                        this.errors = new Errors(error.data.errors).errors
                        this.$emit('error')
                    })
            } else {
                this.$axios
                    .post('/communication', {
                        model: this.modelType,
                        id: this.modelId,
                        type: this.type,
                        value: this.empty.value,
                        primary: this.empty.primary,
                    })
                    .then(() => {
                        this.$emit('hasSaved')
                    })
                    .catch((error) => {
                        this.errors = new Errors(error.data.errors).errors
                        this.$emit('error')
                    })
            }
        },

        destroy() {
            this.empty.removed = !this.empty.removed
        },
    },

    components: {
        // 'ToggleRadio': require('~/components/customer/input/toggle-radio').default
    },
}
</script>
